import { lazy } from 'react'

export const FavouriteFoodsV1 = lazy(() => import('./FavouriteFoodsV1'))
